








































import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";

import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft3sticks from "@/common/components/icons/IconArrowLeft3sticks.vue";

import TheTemplateJ from "@/general/components/templates/TheTemplateJ.vue";
import TheJInputScreen from "@/general/components/pages/parts/GiveThanksPoint/TheJInputScreen.vue";
import TheJPointDestination from "@/general/components/pages/parts/GiveThanksPoint/TheJPointDestination.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import globals from "@/general/store/modules/globals";
import { GiveThanksPoints } from "@/general/store/models";
import ThanksPointApi from "@/general/api/thanksPointApi";
import sitemap from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    CommonHeading,
    IconBase,
    IconArrowLeft3sticks,
    TheTemplateJ,
    TheJInputScreen,
    TheJPointDestination
  }
})
export default class GiveThanksPoint extends Vue {
  backUrl = "";

  givingType = 0;

  thanksPointGive: any = {};

  breadcrumb: any = [
    {
      text: "",
      url: sitemap.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "サンクスメッセージ",
      url: sitemap.THANKS_POINT,
      pageType: "lower"
    },
    {
      text: "感謝のメッセージを贈る",
      url: "",
      pageType: "lower"
    }
  ];

  $refs!: {
    theHeader: TheHeader;
  };

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  get icon() {
    return this.thanksPointGive.icon;
  }

  get name() {
    return this.thanksPointGive.name;
  }

  get availablePoints() {
    return this.thanksPointGive.available_point;
  }

  get pointsToSend() {
    return this.thanksPointGive.points_to_send;
  }

  get maxPoints() {
    return this.thanksPointGive.max_points;
  }

  get minPoints() {
    return this.thanksPointGive.min_points;
  }

  get defaultMessage() {
    return auth.user?.default_thanks_message || "";
  }

  get fixedPoint() {
    return this.thanksPointGive.fixed_point;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let userData = LocalStorage.getItem("sendToUserData") as any;
    userData = JSON.parse(userData);

    const givingType = urlParams.get("giving_type");
    this.givingType = givingType ? parseInt(givingType) : this.givingType;
    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";

    const response: GiveThanksPoints = await ThanksPointApi.getGiveThanksPoints(
      userData.sendTo.id,
      search,
      userData.sendTo.name
    );

    this.thanksPointGive = {
      icon: response?.user_image ? response?.user_image : "",
      name: response?.display_name ? response?.display_name : "",
      min_points: response?.min_points ? response?.min_points : 0,
      max_points: response?.max_points ? response?.max_points : 0,
      points_to_send: response?.points_to_send ? response?.points_to_send : "",
      available_point: response?.total_points ? response?.total_points : 0,
      thanks_point_pattern: response?.thanks_point_pattern
        ? response?.thanks_point_pattern
        : 0,
      fixed_point: response?.fixed_point ? response?.fixed_point : 0
    };

    if (this.givingType !== this.thanksMessageType) {
      window.location.href =
        `${sitemap.THANKS_POINT_GIVE_THANKS_POINT}?giving_type=` +
        this.thanksMessageType;
    }

    this.backUrl = "/thanks-point/user-selection/";
    await commons.setOrgPageSpecificDataFromLocalStorage();
    this.breadcrumb[1].text = this.thanksPointName + "メッセージ";
    await commons.setbreadcrumb(this.breadcrumb);
  }

  get allowPointsRegifting() {
    // const orgAdminSettings = LocalStorage.getItem("orgAdminSettings")
    //   ? JSON.parse(LocalStorage.getItem("orgAdminSettings") as string)
    //   : [];

    // return orgAdminSettings[0].allow_points_regifting;

    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      return userDetailsJson.allow_points_regifting;
    }
    return false;
  }

  get thanksMessageType() {
    return this.thanksPointGive.thanks_point_pattern
      ? this.thanksPointGive.thanks_point_pattern
      : this.givingType;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }
}
